import './stock-bound-skeleton.scss';

import Skeleton from 'antd/lib/skeleton';

const StockBoundSkeleton: React.FC = () => {
  return [1, 2, 3, 4].map((item) => (
    <div className="stock-bound-skeleton" key={item}>
      <Skeleton.Button
        active
        size="small"
        shape="round"
        classNames={{
          content: 'stock-bound-skeleton__switch'
        }}
      />
      <Skeleton.Input
        active
        classNames={{
          content: 'stock-bound-skeleton__text'
        }}
      />
    </div>
  ));
};

export default StockBoundSkeleton;
